<template>
    <div class="items_container">
        <div class="container">
            <p class="b" @click="onURL(1)">五福临门</p>
            <p @click="onURL(2)">八方来财</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "items",
  data() {
      return{
          username:"",
      }
  },
  created() {

    var query = this.$route.query
    if(query.name != undefined){
      this.username = query.name;
    }
  },
  methods:{
      onURL(value){
          if(value==2){
            this.$router.push({path:"/statics"});
          }else{
            this.$router.push({path:"/xzt"});

          }
      }
  }
}
</script>

<style scoped lang="less">
    .items_container{
        height: 100%;
        .container{
            width:200px;
            margin: auto;
            height: 300px;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
         p{
            height:100px;
            line-height: 100px;
            font-size: 30px;
            width: 300px;
            background: red;
            margin-bottom: 10px;
            color: white;
            cursor: pointer;
            
                &.b{
                    background: blue;
                }
            }
        }
       
    }
</style>